import { createContext } from 'react';
import { IPopoverContext } from '../interfaces/IPopoverContext';
import { OpenPopoverProps } from '../interfaces/PopoverState';

export default createContext<IPopoverContext>({
  popover: {
    isOpen: false,
    name: null,
  },
  popoverNode: null,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  openPopover: (props: OpenPopoverProps): void => {
    throw new Error('openPopover: (): void not implemented');
  },
  closePopover: (): void => {
    throw new Error('closePopover: (): void not implemented');
  },
});
